
// export default ReclamosForm;
import React, { useState, useRef, useEffect } from 'react';
import { InputLabel, Button, TextField, Select, FormControl, Radio } from '@material-ui/core';
import { createMuiTheme, makeStyles, withStyles, ThemeProvider } from '@material-ui/core/styles';
import { green } from '@material-ui/core/colors';
import moment from 'moment';
import Api from '../../Api/Api';
import { Link } from 'react-router-dom';
import Snackbar from '@material-ui/core/Snackbar';
import '@material/react-snackbar/dist/snackbar.css';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import ReCaptchaV2 from 'react-google-recaptcha';

const theme = createMuiTheme({
  palette: {
    primary: { light: '#83BC00', main: '#83BC00', dark: 'green', contrastText: '#fff' },
    secondary: green,
  },
});

const useStyles = makeStyles((theme) => ({
  formControl: { margin: theme.spacing(2), minWidth: 120 },
  button: { fontWeight: 'bold', margin: theme.spacing(1) },
}));

const GreenRadio = withStyles({
  root: { color: '#83BC00', '&$checked': { color: '#83BC00' } },
  checked: {},
})((props) => <Radio color="default" {...props} />);

const MAX_INT_32 = 2147483647; // 10 dígitos

const ReclamosForm = () => {
  const classes = useStyles();

  // Snackbar
  const [sna, setSna] = useState({ open: false, vertical: 'top', horizontal: 'center' });
  const { vertical, horizontal } = sna;

  // Label width (MUI v4)
  const inputLabel = useRef(null);
  const [labelWidth, setLabelWidth] = useState(0);
  useEffect(() => { setLabelWidth(inputLabel.current?.offsetWidth || 0); }, []);

  // Estado del formulario
  const [state, setState] = useState({
    categoria: [],
    resultado: {
      tipodeTramite: 0,
      tipoPersona: 0,
      siniestro: '',
      telParticular: '',
      telLaboral: '',
      telCelular: '',
      provincia: '',
      localidad: '',
      direccion: '',
      email: '',
      tema: 0,
      temaDesc: '',
      categoria: 0,                // numérico para payload
      categoriaEncoded: '',        // string del option seleccionado
    },
    contacto: {
      interno: 0,
      docTipo: 0,
      cuitNro: '',
      docNro: '',
      trabajadorEmpleador: '',
      nombre: '',
    },
    detalles: {
      interno2: 0,
      reclamoConsulta: 0,
      ingreso: null,
      medio: 0,
      asunto: '',
      cuerpo: '',
      movimiento: 'E',
      operador: 0,
      revision: null,
    },
    token: null,
  });

  const [sb, setsb] = useState({ showSnackBar: false, mensajeSnackbar: '', severitySnackbar: '' });
  const [enviando, setEnviando] = useState(false);

  // Helpers categorías por tema
  const valorCategoria = (v) => {
    switch (v) {
      case 1: return [{ cod: 0, desc: '' }, { cod: 1, desc: 'Alcance de la Cobertura' }, { cod: 2, desc: 'Presentacion de Documentos' }, { cod: 3, desc: 'Tarifas' }, { cod: 4, desc: 'Otros' }];
      case 2: return [{ cod: 0, desc: '' }, { cod: 5, desc: 'Solicitud de Documentacion para Tramite' }, { cod: 6, desc: 'Turnos' }, { cod: 7, desc: 'Otros' }];
      case 3: return [{ cod: 0, desc: '' }, { cod: 8, desc: 'Exámenes Periódicos' }];
      case 4: return [{ cod: 0, desc: '' }, { cod: 9, desc: 'Pago de Incapacidades' }, { cod: 10, desc: 'Pago Directo de ILT' }, { cod: 11, desc: 'Reintegro de ILT' }, { cod: 12, desc: 'Otros' }];
      case 5: return [{ cod: 0, desc: '' }, { cod: 13, desc: 'Demora en Prestaciones' }, { cod: 14, desc: 'Reintegro de Gastos' }, { cod: 15, desc: 'Solicitud de Historia Clinica' }, { cod: 16, desc: 'Traslado' }, { cod: 17, desc: 'Turno' }, { cod: 18, desc: 'Otros' }];
      case 6: return [{ cod: 0, desc: '' }, { cod: 19, desc: 'Presentacion de Documentos' }, { cod: 20, desc: 'Visitas a Establecimientos' }, { cod: 21, desc: 'Otros' }];
      case 7: return [{ cod: 0, desc: '' }, { cod: 22, desc: 'Otros' }];
      default: return [];
    }
  };

  // Atajos a sub-estados
  let categoria = state.categoria;
  let resultado = { ...state.resultado };
  let contacto = { ...state.contacto };
  let detalles = { ...state.detalles };

  const valueToState = ({ name, value }) => {
    if (name === 'tema') {
      const [codTema, descTema] = JSON.parse(value);
      resultado.tema = Number(codTema);
      resultado.temaDesc = descTema;
      categoria = valorCategoria(resultado.tema);
      resultado.categoria = 0;
      resultado.categoriaEncoded = '';
      detalles.asunto = `Tema: ${descTema}`;
    } else if (name === 'categoria') {
      const [codCat, descCat] = JSON.parse(value);
      resultado.categoria = Number(codCat);
      resultado.categoriaEncoded = value; // controlado
      detalles.asunto = `Tema: ${resultado.temaDesc} - Categoria: ${descCat}`;
    } else if (name === 'siniestro') {
      // guardo como string para controlar longitud
      resultado.siniestro = value.replace(/\D/g, '');
    } else {
      resultado[name] = value;
    }

    setState({ ...state, categoria, resultado, contacto, detalles });
  };

  const valueToStateContacto = ({ name, value, checked, type }) => {
    contacto[name] = type === 'checkbox' ? checked : value;
    setState({ ...state, categoria, resultado, contacto, detalles });
  };

  const valueToStateDetalle = ({ name, value }) => {
    detalles[name] = value;
    setState({ ...state, categoria, resultado, contacto, detalles });
  };

  const trabajadorEmpleadorSTR = (e) => (e === '1' ? 'Trabajador' : e === '2' ? 'Empleador' : 'Otro');
  const tipoTramiteSTR = (e) => (e === '1' ? 'Consulta' : e === '2' ? 'Reclamo' : 'Reclamo');

  // Validaciones
  const validate = () => {
    let nameError = '';

    if (state.contacto.trabajadorEmpleador === '') nameError = 'Debe seleccionar un Tipo de Usuario (Trabajador/Empleador/Otro)';
    if (state.contacto.trabajadorEmpleador === '1' && !Number(state.contacto.docNro)) nameError = 'Debe ingresar su Numero de DNI';
    if (state.contacto.trabajadorEmpleador === '2' && !Number(state.contacto.cuitNro)) nameError = 'Debe ingresar su CUIT';
    if (!state.resultado.telParticular && !state.resultado.telLaboral && !state.resultado.telCelular) nameError = 'Debe ingresar al menos un teléfono de contacto.';
    if (!state.resultado.categoria || Number(state.resultado.categoria) === 0) nameError = 'Debe seleccionar una categoría.';

    // Siniestro: máx 10 dígitos (por BD int)
    const sinStr = (state.resultado.siniestro || '').toString();
    if (sinStr && sinStr.replace(/\D/g, '').length > 10) nameError = 'El Nro. de Siniestro debe tener como máximo 10 dígitos.';

    if (nameError) {
      setsb({ showSnackBar: true, severitySnackbar: 'error', mensajeSnackbar: nameError });
      setSna((s) => ({ ...s, open: true }));
      return false;
    }
    return true;
  };

  // reCAPTCHA
  const handleToken = (token) => setState((curr) => ({ ...curr, token }));
  const handleExpire = () => setState((curr) => ({ ...curr, token: null }));

  const handleClose = (event, reason) => { if (reason !== 'clickaway') setSna((s) => ({ ...s, open: false })); };

  function Snackb({ value, mensaje, tipo }) {
    return value ? (
      <Snackbar
        className="my-snakbar"
        anchorOrigin={{ vertical, horizontal }}
        key={`${vertical},${horizontal}`}
        open={value}
        onClose={handleClose}
        message={mensaje}
        action={
          tipo === 'success' ? (
            <React.Fragment>
              <Link to="/INICIO"><Button color="primary" size="small">OK</Button></Link>
              <Link to="/INICIO"><IconButton size="small" aria-label="close" color="inherit"><CloseIcon fontSize="small" /></IconButton></Link>
            </React.Fragment>
          ) : (
            <React.Fragment>
              <Button color="primary" size="small" onClick={handleClose}>OK</Button>
              <IconButton size="small" aria-label="close" color="inherit" onClick={handleClose}><CloseIcon fontSize="small" /></IconButton>
            </React.Fragment>
          )
        }
      />
    ) : null;
  }

  // Payload correcto
  const buildPayload = (form) => {
    const fechaISO = new Date().toISOString();
    const fecha2 = moment().format('DD-MM-YYYY HH:mm:ss');

    const medios = [];
    if (form.resultado.email) medios.push({ Interno: 0, Contacto: 0, Tipo: 'E', Direccion: form.resultado.email });
    if (form.resultado.telParticular) medios.push({ Interno: 0, Contacto: 0, Tipo: 'T', Direccion: form.resultado.telParticular });
    if (form.resultado.telLaboral) medios.push({ Interno: 0, Contacto: 0, Tipo: 'T', Direccion: form.resultado.telLaboral });
    if (form.resultado.telCelular) medios.push({ Interno: 0, Contacto: 0, Tipo: 'T', Direccion: form.resultado.telCelular });

    const RefReclamoConsultaContacto = {
      Interno: 0,
      DocTipo: form.contacto.trabajadorEmpleador === '2' ? 80 : 96,
      DocNro: Number(form.contacto.trabajadorEmpleador === '2' ? form.contacto.cuitNro : form.contacto.docNro || 0),
      TrabajadorEmpleador: Number(form.contacto.trabajadorEmpleador || 0),
      Nombre: form.contacto.nombre,
      RefReclamoConsultaMedio: medios,
    };

    const RefReclamoConsultaDetalle = {
      Interno: 0,
      ReclamoConsulta: 0,
      Ingreso: fechaISO,
      Medio: 0,
      Asunto: form.detalles.asunto ?? '',
      Cuerpo: form.detalles.cuerpo ?? '',
      Movimiento: 'E',
      Operador: 0,
      Revision: null,
      CuerpoHtml:
        '<b> Tipo de Tramite: </b>' + tipoTramiteSTR(String(form.resultado.tipodeTramite)) + ' <p>' +
        '<b>Trabajador/Empleador: </b>' + trabajadorEmpleadorSTR(String(form.contacto.trabajadorEmpleador)) + '<p>' +
        '<b>Siniestro: </b>' + (form.resultado.siniestro || '') + '<p>' +
        '<b>Nombre-Apellido/Razón Social: </b>' + form.contacto.nombre + '<p>' +
        '<b>DNI: </b>' + (form.contacto.docNro || '') + '<p>' +
        '<b>CUIT: </b>' + (form.contacto.cuitNro || '') + '<p>' +
        '<b>Celular: </b>' + (form.resultado.telCelular || '') + '<p>' +
        '<b>Teléfono Particular: </b>' + (form.resultado.telParticular || '') + '<p>' +
        '<b>Teléfono Laboral: </b>' + (form.resultado.telLaboral || '') + '<p>' +
        '<b>Provincia: </b>' + (form.resultado.provincia || '') + '<p>' +
        '<b>Localidad: </b>' + (form.resultado.localidad || '') + '<p>' +
        '<b>Dirección: </b>' + (form.resultado.direccion || '') + '<p>' +
        '<b>E-mail: </b>' + (form.resultado.email || '') + '<br><br>' +
        '<u><b>Asunto: </b>' + (form.detalles.asunto || '') + '</u><p> ' +
        '<b>Mensaje: </b>' + (form.detalles.cuerpo || '') + '<br><br> ' +
        '<b>Fecha/Hora: </b>' + fecha2 + '<p> ',
      SectorInterno: 0,
      OperadorReasigna: 0,
    };

    // Siniestro seguro (INT)
    let siniestro = 0;
    if (form.resultado.siniestro) {
      const parsed = parseInt(String(form.resultado.siniestro).replace(/\D/g, ''), 10);
      siniestro = Number.isFinite(parsed) ? Math.min(parsed, MAX_INT_32) : 0;
    }

    return {
      Interno: 0,
      Operador: 4,
      Origen: 1,
      Tramite: Number(form.resultado.tipodeTramite || 0),
      Tema: Number(form.resultado.tema || 0),
      Categoria: Number(form.resultado.categoria || 0),
      Contacto: 0,
      Apertura: fechaISO,
      Cierre: null,
      Siniestro: siniestro,
      ContactoDomicilioInterno: 0,
      RefReclamoConsultaContacto,
      RefReclamoConsultaDetalle,
      // captchaToken: form.token, // si el backend lo valida
    };
  };

  const submitHandler = async (e) => {
    e.preventDefault();

    if (!validate()) return;

    setEnviando(true); // Deshabilitar botón al empezar a enviar

    const payload = buildPayload(state);
    console.log('Payload que se enviará:', payload);

    try {
      const resp = await Api.post('RefReclamoConsulta/RefReclamoConsultaAgregar', payload, {
        headers: { 'Content-Type': 'application/json' },
      });

      // Enviar correos de notificación
      try {
        // Usar el mismo CuerpoHtml que se guardó en la base de datos (igual que los triggers)
        const cuerpoHtml = payload.RefReclamoConsultaDetalle.CuerpoHtml;
        
        // Cuerpo para la empresa (igual que trigger "email")
        const cuerpoEmpresa = cuerpoHtml + 'Nro de Reclamo-Consulta: ' + resp.data;

        // Cuerpo para el usuario (igual que trigger "NotificacionAlUsuario")
        const cuerpoUsuario = 
          'Sr/Sra: ' + '<b>' + state.contacto.nombre + '</b>' +
          '<p>' + 'Su Consulta ha sido registrada bajo el Nro: ' + resp.data +
          '<p>' + 'Los datos que usted ingresó son los siguientes: ' + '<p>' + 
          cuerpoHtml;

        // 1. Enviar correo a la EMPRESA
        // Asunto profesional para la bandeja de entrada
        //email original del envio a la empresa = consultasreclamos@artmutualrural.org.ar
        //email para cc = atencion.clientes@artmutualrural.org.ar
        const emailEmpresa = {
          to: ["consultasreclamos@artmutualrural.org.ar"],
          cc: ["atencion.clientes@artmutualrural.org.ar"],
          bcc: [],
          attachments: [],
          asunto: "",
          cuerpo: cuerpoEmpresa,
          pie: ""
        };

        // Endpoint de produccion de envío de emails = https://arttest.intersistemas.ar:8302/api/Email
        await fetch('https://api.artmutualrural.org.ar:8302/api/Email', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(emailEmpresa)
        });

        console.log('Correo a la empresa enviado exitosamente');
 
        // 2. Enviar correo al USUARIO (si tiene email)
        if (state.resultado.email) {
          const emailUsuario = {
            to: [state.resultado.email],
            cc: [],
            bcc: [],
            attachments: [],
            asunto: '',
            cuerpo: cuerpoUsuario,
            pie: ""
          };
          // Endpoint de desarrollo de envío de emails = https://localhost:44362/api/Email
          await fetch('https://api.artmutualrural.org.ar:8302/api/Email', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(emailUsuario)
          });

          console.log('Correo de confirmación al usuario enviado exitosamente');
        }
      } catch (emailError) {
        console.error('Error al enviar los correos de notificación:', emailError);
        // No mostramos error al usuario, ya que el reclamo se registró correctamente
      }

      setsb({
        showSnackBar: true,
        severitySnackbar: 'success',
        mensajeSnackbar: 'Se registró con éxito su Consulta con el Nro de trámite ' + resp.data + '! Nos pondremos en contacto.',
      });
      setSna((s) => ({ ...s, open: true }));
      return resp;
    } catch (error) {
      const dump = (d) => { try { return typeof d === 'string' ? d : JSON.stringify(d, null, 2); } catch { return '[no serializable]'; } };
      console.error('HTTP error desde backend', {
        url: error.config?.url,
        method: error.config?.method,
        status: error.response?.status,
        data: dump(error.response?.data),
      });
      setsb({ showSnackBar: true, severitySnackbar: 'error', mensajeSnackbar: 'Error al enviar la Consulta!' });
      setSna((s) => ({ ...s, open: true }));
      setEnviando(false); // Rehabilitar botón si hay error
    }
  };

  return (
    <ThemeProvider theme={theme}>
      <form onSubmit={submitHandler}>
        <div className="form-reclamos">
          <FormControl variant="outlined" className={classes.formControl}>
            <InputLabel ref={inputLabel} htmlFor="tipodeTramite">Tramite</InputLabel>
            <Select native labelWidth={labelWidth} name="tipodeTramite" onChange={(e) => valueToState(e.target)} required>
              <option value="" />
              <option value={1}>Consulta</option>
              <option value={2}>Reclamo</option>
            </Select>
          </FormControl>

          <div className="form-reclamos" style={{ alignSelf: 'center' }}>
            <label style={{ margin: '0% 5%' }}>
              Trabajador
              <GreenRadio type="radio" name="trabajadorEmpleador" checked={state.contacto.trabajadorEmpleador === '1'} onChange={(e) => valueToStateContacto(e.target)} value="1" />
            </label>
            <label style={{ margin: '0% 5%' }}>
              Empleador
              <GreenRadio type="radio" name="trabajadorEmpleador" checked={state.contacto.trabajadorEmpleador === '2'} onChange={(e) => valueToStateContacto(e.target)} value="2" />
            </label>
            <label style={{ margin: '0% 5%' }}>
              Otro
              <GreenRadio type="radio" name="trabajadorEmpleador" checked={state.contacto.trabajadorEmpleador === '0'} onChange={(e) => valueToStateContacto(e.target)} value="0" />
            </label>
          </div>
        </div>

        <div className="form-reclamos">
          <FormControl className={classes.formControl}>
            <TextField label="Nombre-Apellido / Razón Social" variant="outlined" name="nombre" color="primary" type="text" onChange={(e) => valueToStateContacto(e.target)} required />
          </FormControl>
          <FormControl className={classes.formControl}>
            <TextField label="DNI" variant="outlined" name="docNro" type="number" onChange={(e) => valueToStateContacto(e.target)} required={state.contacto.trabajadorEmpleador === '1'} />
          </FormControl>
          <FormControl className={classes.formControl}>
            <TextField label="CUIT" variant="outlined" name="cuitNro" type="number" onChange={(e) => valueToStateContacto(e.target)} required={state.contacto.trabajadorEmpleador === '2'} />
          </FormControl>
        </div>

        <div className="form-reclamos">
          <FormControl className={classes.formControl}><TextField label="Teléfono Celular" variant="outlined" name="telCelular" type="tel" onChange={(e) => valueToState(e.target)} /></FormControl>
          <FormControl className={classes.formControl}><TextField label="Teléfono Particular" variant="outlined" name="telParticular" type="tel" onChange={(e) => valueToState(e.target)} /></FormControl>
          <FormControl className={classes.formControl}><TextField label="Teléfono Laboral" variant="outlined" name="telLaboral" type="tel" onChange={(e) => valueToState(e.target)} /></FormControl>
        </div>

        <div className="form-reclamos">
          <FormControl className={classes.formControl}><TextField label="Provincia." variant="outlined" placeholder="Provincia." name="provincia" type="text" onChange={(e) => valueToState(e.target)} required /></FormControl>
          <FormControl className={classes.formControl}><TextField label="Localidad." variant="outlined" placeholder="Localidad." name="localidad" type="text" onChange={(e) => valueToState(e.target)} required /></FormControl>
          <FormControl className={classes.formControl}><TextField label="Domicilio." variant="outlined" placeholder="Domicilio." name="direccion" type="text" onChange={(e) => valueToState(e.target)} required /></FormControl>
        </div>

        <FormControl className={classes.formControl}><TextField label="Email" variant="outlined" name="email" type="email" onChange={(e) => valueToState(e.target)} required /></FormControl>

        <div className="form-reclamos">
          <FormControl variant="outlined" className={classes.formControl}>
            <InputLabel ref={inputLabel} htmlFor="tema">Tema</InputLabel>
            <Select native labelWidth={labelWidth} name="tema" onChange={(e) => valueToState(e.target)} required>
              <option value={JSON.stringify([0, ''])}></option>
              <option value={JSON.stringify([1, 'Afiliaciónes y Contratos'])}>Afiliaciónes y Contratos</option>
              <option value={JSON.stringify([2, 'Comisiones Médicas'])}>Comisiones Médicas</option>
              <option value={JSON.stringify([3, 'Exámenes Periódicos'])}>Exámenes Periódicos</option>
              <option value={JSON.stringify([4, 'Prestaciones Dinerarias'])}>Prestaciones Dinerarias</option>
              <option value={JSON.stringify([5, 'Prestaciones en Especie'])}>Prestaciones en Especie</option>
              <option value={JSON.stringify([6, 'Prevención'])}>Prevención</option>
              <option value={JSON.stringify([7, 'Otros'])}>Otros</option>
            </Select>
          </FormControl>

          <FormControl variant="outlined" className={classes.formControl}>
            <InputLabel ref={inputLabel} htmlFor="categoria">Categoria</InputLabel>
            <Select
              native
              labelWidth={labelWidth}
              name="categoria"
              value={state.resultado.categoriaEncoded || ''}
              onChange={(e) => valueToState(e.target)}
              required
            >
              <option value="" disabled>Seleccioná una categoría</option>
              {state.categoria.map((cat) => (
                <option value={JSON.stringify([cat.cod, cat.desc])} key={cat.cod}>{cat.desc}</option>
              ))}
            </Select>
          </FormControl>

          <FormControl className={classes.formControl}>
            <TextField
              label="Nro. de Siniestro (en caso de conocerlo)"
              variant="outlined"
              name="siniestro"
              type="text"
              inputProps={{ inputMode: 'numeric', pattern: '[0-9]*', maxLength: 10 }}
              onChange={(e) => valueToState(e.target)}
            />
          </FormControl>
        </div>

        <div className="contact-form">
          <div className={classes.formControl}>
            <label>Mensaje:</label>
            <textarea
              style={{ borderRadius: '4px' }}
              name="cuerpo"
              placeholder="Escriba su consulta"
              onChange={(e) => valueToStateDetalle(e.target)}
              required
            />
          </div>
        </div>

        <div className="d-grid col" style={{ textAlign: '-webkit-center' }}>
          <div>
            <ReCaptchaV2 sitekey="6Le2BN4aAAAAAAmszeHqg7NmclYXPoaqC0PXoypW" onChange={handleToken} onExpire={handleExpire} />
          </div>

          <div style={{ marginBottom: '15%' }}>
            <ThemeProvider theme={theme}>
              <Link to="/INICIO"><Button variant="contained" color="primary" className={classes.button}>Cancelar</Button></Link>
              <Button type="submit" variant="contained" color="primary" disabled={enviando || sb.severitySnackbar === 'success'} className={classes.button}>
                {enviando ? 'Enviando...' : 'Enviar'}
              </Button>
            </ThemeProvider>
          </div>
        </div>
      </form>

      {sb.showSnackBar ? <Snackb value={sb.showSnackBar} mensaje={sb.mensajeSnackbar} tipo={sb.severitySnackbar} /> : null}
    </ThemeProvider>
  );
};

export default ReclamosForm;
